import { createFileRoute } from "@tanstack/react-router";
import { ShutdownPage, shutdownHead } from "@/pages/ShutdownPage";

export const Route = createFileRoute("/shutdown-planlaegning")({
  head: () => shutdownHead("da"),
  component: () => <ShutdownPage locale="da" />,
});
